module.exports = __webpack_public_path__ + "static/media/closemodalicon.0a140154.svg";